
import { useState, useEffect } from "react"
import "../Css_files/Full_gallery.css"
import Navbar from "./Navbar"
import FeaturedSlider from "./FeaturedSlider"
import CategoryFilter from "./CategoryFilter"
import ViewToggle from "./ViewToggle"
import GalleryGrid from "./GalleryGrid"
import ImageModal from "./ImageModal"
import CompanyHeader from "./CompanyHeader"
import Footer from "./Footer"
import img1 from "../Images/award.jpeg"
import img2 from "../Images/patnership.jpg"
import img3 from "../Images/Team-members.jpeg"
import img4 from "../Images/gallery img1.jfif"
import img5 from "../Images/gallery img2.jpeg"
import img6 from "../Images/project1.jpg"
import img7 from "../Images/team 1.jpg"
import img8 from "../Images/gallery img3.jpg"
import img9 from "../Images/gallery img4.jpeg"
import img10 from "../Images/gallery img5.JPG"
import img11 from "../Images/gallery img6.jfif"
import img12 from "../Images/gallery img6.jpg"

const GalleryShowcase = () => {
  const [activeCategory, setActiveCategory] = useState("All")
  const [viewMode, setViewMode] = useState("grid")
  const [selectedAchievement, setSelectedAchievement] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [filteredAchievements, setFilteredAchievements] = useState([])

  const achievements = [
    {
      id: 1,
      title: "Best Tech Innovation Award 2024",
      description:
        "Recognized for groundbreaking AI solutions that transformed client operations and delivered exceptional ROI across multiple industry verticals.",
      image: img1,
      date: "03/15/2024",
      category: "Awards",
    },
    {
      id: 2,
      title: "Global Partnership Milestone",
      description:
        "Successfully established strategic partnerships with 50+ international clients across 15 countries, expanding our global footprint significantly.",
      image: img2,
      date: "01/20/2024",
      category: "Partnerships",
    },
    {
      id: 3,
      title: "Team Excellence Recognition",
      description:
        "Our dedicated team of 200+ professionals achieved 99.8% client satisfaction rating this quarter, setting new industry standards.",
      image: img3,
      date: "02/10/2024",
      category: "Team",
    },
    {
      id: 4,
      title: "Sustainability Initiative Launch",
      description:
        "Launched comprehensive green technology program reducing carbon footprint by 40% across all operations and client projects.",
      image: img4,
      date: "04/05/2024",
      category: "Sustainability",
    },
    {
      id: 5,
      title: "Annual Company Retreat 2024",
      description:
        "Memorable team building experience in the mountains, strengthening bonds and fostering innovation through collaborative activities.",
      image: img5,
      date: "05/12/2024",
      category: "Team",
    },
    {
      id: 6,
      title: "Civil Projects",
      description:
        "Delivered transformative digital solution for major Fortune 500 company, resulting in 300% efficiency improvement and $2M cost savings.",
      image: img6,
      date: "06/08/2024",
      category: "Projects",
    },
    {
      id: 7,
      title: "Industry Leadership Award",
      description:
        "CEO recognized as Technology Leader of the Year for driving innovation and excellence in enterprise software solutions.",
      image: img7,
      date: "07/22/2024",
      category: "Awards",
    },
    {
      id: 8,
      title: "New Office Inauguration",
      description:
        "Opened state-of-the-art development center in Silicon Valley, featuring cutting-edge facilities and collaborative workspaces.",
      image: img8,
      date: "04/30/2024",
      category: "Milestones",
    },
    {
      id: 9,
      title: "Community Outreach Program",
      description:
        "Launched educational initiative providing free coding workshops to 500+ underprivileged students, fostering next-generation talent.",
      image: img9,
      date: "03/25/2024",
      category: "Community",
    },
    {
      id: 10,
      title: "Product Launch: AI Platform",
      description:
        "Successfully launched revolutionary AI platform that automates complex business processes, serving 10,000+ users within first month.",
      image: img10,
      date: "05/18/2024",
      category: "Projects",
    },
    {
      id: 11,
      title: "International Expansion",
      description:
        "Established operations in 5 new countries across Asia-Pacific region, bringing innovative solutions to emerging markets.",
      image: img11,
      date: "06/15/2024",
      category: "Partnerships",
    },
    {
      id: 12,
      title: "Innovation Lab Opening",
      description:
        "Unveiled cutting-edge research facility dedicated to emerging technologies including quantum computing and blockchain solutions.",
      image: img12,
      date: "07/10/2024",
      category: "Milestones",
    },
  ]

  const categories = ["All", "Awards", "Partnerships", "Team", "Projects", "Sustainability", "Milestones", "Community"]

  useEffect(() => {
    if (activeCategory === "All") {
      setFilteredAchievements(achievements)
    } else {
      setFilteredAchievements(achievements.filter((achievement) => achievement.category === activeCategory))
    }
  }, [activeCategory])

  const handleImageClick = (achievement) => {
    setSelectedAchievement(achievement)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setSelectedAchievement(null)
  }

  return (
    <div className="gallery-showcase">
      <div className="gallery-container">
        {/* Company Header */}
        <Navbar />
        <br></br>
        <br></br>
        <br></br>
        <CompanyHeader />
        {/* Featured Slider */}
        <FeaturedSlider />
        {/* Controls Section */}
        <div className="controls-section">
          <div className="controls-filter">
            <CategoryFilter
              categories={categories}
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
            />
          </div>
          <ViewToggle viewMode={viewMode} onViewModeChange={setViewMode} />
        </div>
        {/* <AchievementCard/> */}
        {/* Results Counter */}
        <div className="results-counter">
          <p className="results-text">
            Showing {filteredAchievements.length} {filteredAchievements.length === 1 ? "achievement" : "achievements"}
            {activeCategory !== "All" && ` in ${activeCategory}`}
          </p>
        </div>
        {/* Gallery Grid */}
        <GalleryGrid achievements={filteredAchievements} viewMode={viewMode} onImageClick={handleImageClick} />
        {/* Empty State */}
        {filteredAchievements.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">
              <span>📷</span>
            </div>
            <h3 className="empty-title">No achievements found</h3>
            <p className="empty-description">Try selecting a different category to see more content.</p>
          </div>
        )}
        {/* Image Modal */}
        <ImageModal achievement={selectedAchievement} isOpen={isModalOpen} onClose={handleCloseModal} />
      </div>
      <Footer />
    </div>
  )
}

export default GalleryShowcase
